var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAudioOff = function SvgAudioOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 1.5,
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99 9.017h0v13.966h4.63l6.983 6.983V20.63M28.487 22.819h0c.04-.074.08-.154.136-.271.112-.235.313-.66.486-1.082a13.864 13.864 0 0 0 .915-3.287c.102-.687.158-1.432.169-2.044s-.023-1.092-.08-1.595-.133-1.029-.262-1.638a12.811 12.811 0 0 0-.617-2.086 17.64 17.64 0 0 0-1.136-2.322 11.694 11.694 0 0 0-1.081-1.542 13.706 13.706 0 0 0-1.203-1.315c-.501-.481-1.151-1.04-1.83-1.513s-1.39-.864-1.918-1.127c-.528-.264-.875-.401-1.167-.509s-.53-.186-.767-.264M20.116 10.761c.149.13.299.262.409.364s.18.177.248.248h0c.068.072.133.14.244.266a5.898 5.898 0 0 1 .973 1.49c.17.365.319.778.419 1.156.1.378.15.72.18 1.001.03.28.041.498.039.78a6.751 6.751 0 0 1-.056.846M11.15 5.486l3.453-3.453v6.906M22.671 28.698l-.324.17a16.819 16.819 0 0 1-.836.396c-.13.057-.247.106-.394.165-.148.06-.326.13-.495.196s-.33.126-.49.186h0M1.855 1.987l28.388 28.388"
  })));
};
export default SvgAudioOff;